import DataAdapter from 'rise-ui/adapters/apis/rise-api/data.js';

export default class CatalogThemeAdapter extends DataAdapter {
  pathForType() {
    return 'catalog-theme-type';
  }
}
